import { login, logout } from '@/api/base'
import { getToken, setToken, removeToken, setTeacherInfo, getTeacherInfo, removeTeacherInfo } from '@/utils/auth'

const user = {
  state: {
    token: getToken(),
    name: '',
    avatar: '',
    roles: [],
    studentListCardData: [],
    interveneObj: {},
    isShowJieRu: false,
    currentViewStudent: {
      school_id: '',
      user_id: '',
      real_sname: '',
      course_id: '',
      topic_id: '',
      lesson_id: '',
      knowledge_code: '',
      stage: '',
      section_sname: '',
      flow_id: '',
      subject_id: '',
      jupiter_stage: '',
      learning_version: '',
      account_id: '',
      question_bank_version: '',
      question_vno: '',
      photoColor: '',
      qId: '',
      msg: '',
      eventMessage: '',
      module_type: '',
      module_name: '',
      today_course_answer: {},
      today_course_knowledge: {},
      today_course_learn: {},
      module_answer: {},
      module_learn: {},
      getQuestionServerTime: '',
      q_forms: '',
    },
    isCutDown: false,
    messageListData: [],
    studentList: [],
    studentReportList: [],
    pageStudentCard: {
      val: {},
      index: '',
      studentListCard: [],
      msg: ''
    },
    currentUserId: '',
    leftStudentCount: '',
    initWaitQuestionsList: {},
    cachedMsg: [],
    questionIdNum: 1,
    myStudentList: {},
    studentMessageList: {},
    messageBusList: {},
    isCloseLeft: false,
    systemTime: '',
    totalGoldCoin: 0,
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_STUDENT_LIST_CARD_DATA: (state, studentListCardData) => {
      state.studentListCardData = studentListCardData
    },
    SET_INTERVENE_OBJ: (state, interveneObj) => {
      state.interveneObj = interveneObj
    },
    SET_JIE_RU: (state, isShowJieRu) => {
      state.isShowJieRu = isShowJieRu
    },
    SET_CURRENT_VIEW_STUDENT: (state, currentViewStudent) => {
      state.currentViewStudent = currentViewStudent
    },
    SET_CUT_DOWN: (state, isCutDown) => {
      state.isCutDown = isCutDown
    },
    SET_MESSAGE_LIST: (state, messageListData) => {
      state.messageListData = messageListData
    },
    SET_STUDENT_LIST: (state, studentList) => {
      state.studentList = studentList
    },
    SET_STUDENT_REPORT_LIST: (state, studentReportList) => {
      state.studentReportList = studentReportList
    },
    SET_PAGE_STUDENT_CARD: (state, pageStudentCard) => {
      state.pageStudentCard = pageStudentCard
    },
    SET_CURRENT_USER_ID: (state, currentUserId) => {
      state.currentUserId = currentUserId
    },
    SET_LEFT_STUDENT_COUNT: (state, leftStudentCount) => {
      state.leftStudentCount = leftStudentCount
    },
    SET_INIT_WAIT_QUESTION_LIST: (state, initWaitQuestionsList) => {
      state.initWaitQuestionsList = initWaitQuestionsList
    },
    SET_CACHED_MSG: (state, cachedMsg) => {
      state.cachedMsg = cachedMsg
    },
    SET_QUESTION_ID_NUM: (state, questionIdNum) => {
      state.questionIdNum = questionIdNum
    },
    SET_MY_STUDENT_LIST: (state, myStudentList) => {
      state.myStudentList = Object.assign({}, myStudentList)
    },
    SET_STUDENT_MESSAGE_LIST: (state, studentMessageList) => {
      state.studentMessageList = Object.assign({}, studentMessageList)
    },
    SET_MESSAGE_BUS_LIST: (state, messageBusList) => {
      state.messageBusList = Object.assign({}, messageBusList)
    },
    SET_IS_CLOSE_LEFT: (state, isCloseLeft) => {
      state.isCloseLeft = isCloseLeft
    },
    SET_SYSTEM_TIME: (state, systemTime) => {
      state.systemTime = systemTime
    },
    TOTAL_GOLD_COIN: (state, data)=>{
      state.totalGoldCoin = data
    }
  },

  actions: {
    // 登录
    Login({ commit }, userInfo) {
      const token = userInfo
      return new Promise((resolve, reject) => {
        login(token).then(response => {
          const data = response.data
          console.log(response)
          // data.token = 'ecyxJpzhdpWJqZWN0X2lkIjoyLCJjb3Vyc2VfaWQiOjEsInNlY3Rpb25faWQiOjEsInRvcGljX2lkIjozNDA0LCJmbG93X2lkIjowLCJzY2hvb2xfaWQiOjEwMDAwLCJ2ZXJpZnkiOiIxMTExMTEifQO0O0OO0O0O'
          // setToken(data.api_key)
          setTeacherInfo(JSON.stringify(data))
          sessionStorage.setItem('teacher_id', data.uid)
          sessionStorage.setItem('teacher_login_time', Date.now())
          sessionStorage.setItem('subject_id', data.subject_id)
          sessionStorage.setItem('teacher_name', data.uname)
          sessionStorage.setItem('app_type', data.app_type + '')
          sessionStorage.setItem('school_id', data.school_id + '')
          sessionStorage.setItem('refer_teacher_id', data.refer_teacher.old_teacher_id)
          sessionStorage.setItem('refer_school_id', data.refer_teacher.school_id)
          sessionStorage.setItem('user_type', data.user_type)
          // sessionStorage.setItem('refer_teacher_id', data.refer_teacher_id || data.teacher_id)
          // sessionStorage.setItem('user_type', data.user_type || 3)
          // commit('SET_TOKEN', data.api_key)
          resolve(response)
          // window.location.reload()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取用户信息
    GetInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        getInfo(state.token).then(response => {
          const data = response.data
          if (data.roles && data.roles.length > 0) { // 验证返回的roles是否是一个非空数组
            commit('SET_ROLES', data.roles)
          } else {
            reject('getInfo: roles must be a non-null array !')
          }
          commit('SET_NAME', data.name)
          commit('SET_AVATAR', data.avatar)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 登出
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(state.token).then(() => {
          commit('SET_TOKEN', '')
          commit('SET_ROLES', [])
          removeToken()
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        removeToken()
        resolve()
      })
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js